<template>
  <LayoutContent>
    <SectionTitle :label="$t('label.reviewUs')" />
    <v-card class="content">
      <div class="text-h5 primary--text text--darken-1 font-weight-bold text-center">{{ $t('label.reviewValuable') }}</div>
      <div class="text-h5 primary--text text--darken-1 font-weight-bold text-center">{{ $t('label.reviewAndClaim') }}</div>
      <v-card-text class=""><img src="@/assets/review-claim-reward.png" /></v-card-text>
      <v-card-actions class="flex flex-column flex-sm-row justify-center align-center">
        <v-btn outlined color="primary darken-1" class="mr-sm-auto px-12 mb-2 mb-sm-0 rounded-pill text-capitalize align-self-center" :to="{ name: $constants.ROUTE_NAME.SALON_STYLIST_REVIEW_LIST }">
          {{ $t('button.doItLater') }}
        </v-btn>
        <v-btn color="primary" class="ml-sm-auto px-10 rounded-pill green-gradient-right text-capitalize align-self-center" :to="{ name: $constants.ROUTE_NAME.SALON_STYLIST_REVIEW_WRITE }">
          {{ $t('button.makeReview') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </LayoutContent>
</template>

<script>
import SectionTitle from '@/components/SectionTitle.vue'
import LayoutContent from '@/views/layouts/LayoutContent.vue'

export default {
  components: { SectionTitle, LayoutContent }
}
</script>
<style lang="scss" scoped>
.content {
  padding-left: 10%;
  padding-right: 10%;
  padding-top: 100px;
  padding-bottom: 40px;

  @media only screen and (min-width: 640px) {
    padding-left: 20%;
    padding-right: 20%;
  }

  @media only screen and (min-width: 1000px) {
    padding-left: 30%;
    padding-right: 30%;
  }
}
</style>
